// IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
// Форма вида ячеек отчёта REPORT2 (дополнение Игоря 01.11 05:10 к p149): те же режимы и слои, но рисуются кругом (circle, cellRing.js), столбиками (bars,
// cellBars.js — слой = свой столбик) или площадью под кривой запаса (area, cellArea.js — только строки запаса, «проба пера»).
// Откуда форма (по убыванию силы): переключатель «Форма» в панели таблицы (WIDGET._cellShape — память виджета, в запись не пишется) → shape строки
// раскладки (_DLRow.shape, если бэк его передаст) → shape кнопки опции вида (колонка Shape строки Options, бэк T0) → circle. Значение shape — одна
// форма или список в порядке предпочтения ('area,bars' / ['area', 'bars']): берётся первая применимая к строке (area — только строке запаса).
// Выключатели (дефолт ВКЛ): fe.ux.cellViewBars (ВЫКЛ — bars рисуется кругом), fe.ux.cellViewArea (ВЫКЛ — area пропускается).
// Чистые функции (без Vue и DOM) — tests/unit/cellBars.test.mjs

export const CELL_SHAPES = ['circle', 'bars', 'area']
export const CELL_SHAPE_DEFAULT = 'circle'
export const CELL_BARS_FLAG = 'fe.ux.cellViewBars'
export const CELL_AREA_FLAG = 'fe.ux.cellViewArea'
// подписи переключателя (ключи t(): en / uk / ru — src/i18n/messages)
export const CELL_SHAPE_TITLES = { circle: 'Circles', bars: 'Bars', area: 'Area' }

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()

// значение shape (строка через запятую / пробел / «|», массив) → список известных форм без повторов, в порядке предпочтения
export function cellShape_parse(v) {
    const arr = Array.isArray(v) ? v : str(v).split(/[\s,;|]+/)
    const out = []
    for (const x of arr) {
        const s = str(x).toLowerCase()
        if (CELL_SHAPES.includes(s) && !out.includes(s)) out.push(s)
    }
    return out
}

// флаги форм (нет читателя / ошибка — ВКЛ) → { bars, area }
export function cellShape_flags(setting) {
    const rd = (k) => { try { return typeof setting === 'function' ? setting(k, true) !== false : true } catch (e) { return true } }
    return { bars: rd(CELL_BARS_FLAG), area: rd(CELL_AREA_FLAG) }
}

// форма ячейки: { override (переключатель панели), row (_DLRow.shape), option (shape кнопки вида), isStock (строка запаса: bool | () => bool), flags } → 'circle' | 'bars' | 'area'.
// Переключатель задаёт форму для всех строк; area неприменима (не строка запаса / флаг ВЫКЛ) — дальше по списку строки и опции, в конце circle
export function cellShape_resolve({ override, row, option, isStock = false, flags = {} } = {}) {
    const f = { bars: flags.bars !== false, area: flags.area !== false }
    let st   // isStock — признак или функция (считается лениво: только если area в списке)
    const stock = () => (st === undefined ? (st = !!(typeof isStock === 'function' ? isStock() : isStock)) : st)
    const ok = (s) => (s === 'area' ? (f.area && stock()) : true)
    const fix = (s) => (s === 'bars' && !f.bars ? 'circle' : s)
    for (const list of [cellShape_parse(override), cellShape_parse(row), cellShape_parse(option)]) {
        for (const s of list) if (ok(s)) return fix(s)
    }
    return CELL_SHAPE_DEFAULT
}

// форма, которую показывает переключатель панели: выбор пользователя, иначе первая форма опции (area — как есть), иначе circle
export function cellShape_panelOf(override, option) {
    const o = cellShape_parse(override)
    if (o.length) return o[0]
    const p = cellShape_parse(option)
    return p.length ? p[0] : CELL_SHAPE_DEFAULT
}

// клик по форме в переключателе: та же форма, что уже выбрана пользователем, — сброс выбора ('' — снова по опции / строке), иначе выбранная форма
export function cellShape_next(override, shape) {
    const s = cellShape_parse(shape)[0] || ''
    if (!s) return str(override)
    return cellShape_parse(override)[0] === s ? '' : s
}

// формы, доступные в переключателе по флагам
export function cellShape_available(flags = {}) {
    return CELL_SHAPES.filter(s => (s === 'bars' ? flags.bars !== false : s === 'area' ? flags.area !== false : true))
}
